import Rellax from "rellax"
export function parallaxInit() {
    new Rellax('.rellax');
}
